import { useEffect, useState } from "react";
import { useEnterpriseShell } from "../contexts/EnterpriseShellContext";
import { TeamTabPanel } from "../components/TeamTabPanel";
import { TeamUpgradePanel } from "../components/TeamUpgradePanel";
import { EnterprisePageLoading } from "../components/EnterprisePageLoading";

export function TeamPage() {
  const {
    me,
    teams,
    selectedTeamId,
    refreshMeAndTeams,
    setWorkspaceMainLoading,
    workspaceAccess,
  } = useEnterpriseShell();
  const [workspaceOverlayLoading, setWorkspaceOverlayLoading] = useState(false);

  useEffect(() => {
    setWorkspaceMainLoading(workspaceOverlayLoading);
    return () => setWorkspaceMainLoading(false);
  }, [workspaceOverlayLoading, setWorkspaceMainLoading]);

  if (me === undefined || teams === null) {
    return <EnterprisePageLoading label="Loading your team" />;
  }

  const resolvedTeamId =
    selectedTeamId && teams.some((t) => t.id === selectedTeamId)
      ? selectedTeamId
      : (teams[0]?.id ?? "");
  const activeTeam = teams.find((t) => t.id === resolvedTeamId) ?? null;
  const teamFeaturesUnlocked =
    workspaceAccess?.teamId === resolvedTeamId
      ? workspaceAccess.hasTeamFeatures
      : activeTeam?.hasTeamFeatures !== false;

  if (activeTeam && !teamFeaturesUnlocked) {
    return (
      <div className="enterprise-tab-shell enterprise-team-page-shell enterprise-team-page-shell--upgrade" data-testid="team-screen">
        <TeamUpgradePanel isOwner={activeTeam.role === "owner"} teamId={activeTeam.id} />
      </div>
    );
  }

  return (
    <div className="enterprise-tab-shell enterprise-team-page-shell" data-testid="team-screen">
      <TeamTabPanel
        teams={teams}
        selectedTeamId={resolvedTeamId}
        me={me}
        onTeamsRefresh={refreshMeAndTeams}
        onWorkspaceSwitchLoading={setWorkspaceOverlayLoading}
        readOnly={workspaceAccess?.canWrite === false}
      />
    </div>
  );
}
